import { z } from 'zod';

/** What the desk does, in the order it is offered: each step reached earns an invite. */
export const STEPS = ['follow', 'telegram', 'trade', 'broker', 'portfolio'] as const;
export type Step = (typeof STEPS)[number];

export const stepSchema = z.enum(STEPS);

export const PATH_INVITES = STEPS.length;

export const PATH_ACTOR = 'system:path';

/** A path as the server reads it or the console draws it. */
interface Steps {
  steps: readonly { step: Step; reached: boolean }[];
}

export interface Path {
  /** Null while seen but not yet kept. */
  steps: readonly { step: Step; reached: boolean; at: Date | null }[];
  /** Members let in on their invite, still in, whose own path is kept whole. */
  friendsDone: number;
}

export const reachedCount = (path: Steps): number => path.steps.filter((s) => s.reached).length;

export const allowanceOf = (path: Path): number => reachedCount(path) + path.friendsDone;

export const pathDone = (path: Steps): boolean => reachedCount(path) === STEPS.length;

/** Every step kept, not only seen: what a note says once, when it is so. */
export const pathKept = (path: Path): boolean => path.steps.every((s) => s.at !== null);

export const nextStep = (path: Steps): Step | null =>
  path.steps.find((s) => !s.reached)?.step ?? null;
